import React, { CSSProperties } from 'react';
import { RequestStatus, ScreenType } from "Constants";
import WaitlistManagementService from 'Services/waitlistmanagement.service';
import WaitlistManagementBtnContainer from "Generic/Buttons/ViewControllerBtns/WaitlistMangementBtnContainter";
import "./styles.sass";
import { MvSortTable } from 'Generic/MvSortTable';

// @ts-ignore
import { LocalizationContext } from "react-localize";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

import { ReservationType } from 'Interfaces/GetReservations';
import { MvResortModal, MvRoomModal } from 'Generic/MvModal';
import { ReservationViewFields, showReservationField, ManagementCompanyType, SiteType } from 'Interfaces/AYPResultInterface';
import moment, { Moment } from 'moment';
import { RoomModal } from 'Interfaces/RoomModalInterface';
import { MvConfirmationModal } from 'Generic/MvConfirmationModal/MvConfirmationModal';

// Constants
import {InitRoomModal} from "Constants/InitInterfaces";

// Utils
import { sortReservations, SortDirection, SortType } from 'Utils/SortWaitlists';
import MultiSelectDate from 'Generic/MultiSelectDate/multi-select-date.component';
import { DropdownOption } from 'Interfaces/MultiSelectDate';
import MvReservationTypeToolTip from 'Generic/ToolTip/MvReservationTypeToolTip/MvReservationTypeToolTip';
import { Position } from 'Generic/ToolTip/ToolTip';
import { ReactAppMode } from 'Interfaces/ReactAppModes';
import {EXEC_MODE} from "../../../cfg";
import { WaitlistManagementType } from 'Interfaces/WaitlistManagementInterfaces';
import BookingInfoExists from '../ApplyYourPoints/BookingInfoExists';


enum ModalTypes {
    ROOM_MODAL = "room_modal",
};

type Props = {
    token: string;
    lang: string;
    resId: number;
    setScreenType(screenType: ScreenType, aypResId?: number, waitListId?: number): void;
    screenType?: string;
    apiTimeout: string;
};

type State = {
    waitlists: any[];
    activeBtn: WaitlistManagementType;
    [WaitlistManagementType.Active]: {
        requestStatus: RequestStatus;
        waitlists: any[];
        totalWaitlists: any[];
        defaultYears: number[];
        datesFilter: DropdownOption[];
        activeSortField: SortType;
        SortFields: {
            [SortType.TRANSACTION_DATE]: {
                curSortDirection: SortDirection;
                defaultSortDirection: SortDirection;
            };
            [SortType.WAITLISTID]: {
                curSortDirection: SortDirection;
                defaultSortDirection: SortDirection;
            };
        };
    },
    [WaitlistManagementType.InActive]: {
        requestStatus: RequestStatus;
        waitlists: any[];
        totalWaitlists: any[];
        defaultYears: number[];
        datesFilter: DropdownOption[];
        activeSortField: SortType;
        SortFields: {
            [SortType.TRANSACTION_DATE]: {
                curSortDirection: SortDirection;
                defaultSortDirection: SortDirection;
            };
            [SortType.WAITLISTID]: {
                curSortDirection: SortDirection;
                defaultSortDirection: SortDirection;
            };
        };
    },
    roomModal: RoomModal;
    resortModal: {
        show: boolean;
        propertyCode: string;
    };
    windowWidth: number;
    windowHeight: number;
    showErrorModal: boolean;
    errorMessage: string;
    [ModalTypes.ROOM_MODAL]: RoomModal,
    roomModalLoaded: boolean;
    singleRoomInfo: any;
} 

const InitState: State = {
    waitlists: [],
    activeBtn: WaitlistManagementType.Active,
    [WaitlistManagementType.Active]: {
        requestStatus: RequestStatus.LOADING,
        waitlists: [],
        totalWaitlists: [],
        datesFilter: [],
        defaultYears:[],
        activeSortField: SortType.TRANSACTION_DATE,
        SortFields: {
            [SortType.TRANSACTION_DATE]: {
                curSortDirection: SortDirection.ASC,
                defaultSortDirection: SortDirection.ASC,
            },
            [SortType.WAITLISTID]: {
                curSortDirection: SortDirection.DESC,
                defaultSortDirection: SortDirection.DESC,
            },
        },
    },
    [WaitlistManagementType.InActive]: {
        requestStatus: RequestStatus.LOADING,
        waitlists: [],
        totalWaitlists: [],
        defaultYears:[],
        datesFilter: [],
        activeSortField: SortType.TRANSACTION_DATE,
        SortFields: {
            [SortType.TRANSACTION_DATE]: {
                curSortDirection: SortDirection.DESC,
                defaultSortDirection: SortDirection.DESC,
            },
            [SortType.WAITLISTID]: {
                curSortDirection: SortDirection.DESC,
                defaultSortDirection: SortDirection.DESC,
            },
        },
    },
    roomModal: Object.assign(InitRoomModal, {}),
    resortModal: {
      show: false,
      propertyCode: '',
    },
    windowWidth: 0,
    windowHeight: 0,
    showErrorModal: false,
    errorMessage: '',
    [ModalTypes.ROOM_MODAL]: Object.assign(InitRoomModal, {}),
    roomModalLoaded: false,
    singleRoomInfo: {}, 
}

class WaitlistManagement extends React.Component<Props, State> {
    WaitlistManagementService: WaitlistManagementService;
    _isMounted: boolean;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.WaitlistManagementService = new WaitlistManagementService();
        this.setActive = this.setActive.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onYearFilterSelection = this.onYearFilterSelection.bind(this);
        this.getDateFilterOptions = this.getDateFilterOptions.bind(this);
        this.getYearFromDate = this.getYearFromDate.bind(this);
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.setActive(WaitlistManagementType.Active);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    setActive = (key:WaitlistManagementType) =>{
        const { localize } = this.context;

        if (this.state[key].waitlists.length === 0) {
            const newLoadingState = {...this.state}; 
            newLoadingState[key].requestStatus = RequestStatus.LOADING;
            newLoadingState.activeBtn = key;

            this.setState(newLoadingState, () => {
                this.WaitlistManagementService.getWaitlistManagementData(key).then(waitlists => {
                    const newState = {...this.state};
                    const sortedWaitlists = sortReservations(waitlists.waitlists, key);
                    newState[key].waitlists =  sortedWaitlists;
                    newState[key].totalWaitlists = sortedWaitlists;
                  //  newState[key].datesFilter = waitlists.sortFilter && waitlists.sortFilter.year ? this.getDateFilterOptions(waitlists.sortFilter.year.range) : [];
                  //  const defaultYear = waitlists.sortFilter && waitlists.sortFilter.year ? waitlists.sortFilter.year.default : moment().year();
                  //  newState[key].defaultYears = [defaultYear, defaultYear-1];
                    newState[key].requestStatus = RequestStatus.LOADED;
                    this.setState(newState);
                    console.log({reservationsRequest:waitlists});
                    //TODO: As per the comment in 1771, we are not displaying default years filters. This may need in the future if we want to implement default year logic 
                    // if(key === WaitlistManagementType.InActive || key === WaitlistManagementType.CANCELED ){
                    //     this.onYearFilterSelection([], key);
                    // }
                }).catch(error => {
                    console.log({error})
                    const newErroredState = {...this.state}; 
                    newErroredState[key].requestStatus = RequestStatus.ERRORED;

                    if (error.code !== 401) {
                        const newErroredState = {...this.state}; 
                        newErroredState[key].requestStatus = RequestStatus.ERRORED;
                        newErroredState.showErrorModal = true;
                        newErroredState.errorMessage = error.message;

                        this.setState(newErroredState);
                    } else {
                        this.setState(newErroredState);
                    }
                });
            });
        } else {
            this.setState({ activeBtn: key }); 
        }
    }

    toggleErrorModal = () =>  {
        this.setState({showErrorModal: !this.state.showErrorModal});
    }

    showAllColumns() {
        return this.state.windowWidth > 900;
    }

    getDateFilterOptions(years: number[] = []){
        if(years && years.length){
            years.reverse();
            const options = years.map(item => {
                return {year: item, checked: false}
            });
            return options;
        }
        return [];
    }

    /**
     * return the array of headers for the Reservations table
     */
    reservationsTableHeaders(resType: WaitlistManagementType) {
        const { localize } = this.context;

        // if (this.state[this.state.activeBtn].requestStatus === RequestStatus.LOADED && this.state[resType].waitlists.length === 0)
        //     return [];

        const showAll = this.showAllColumns();
        
        let headers = [
            {
                text:  localize("Waitlist ID"), //localize("static.content.waitlistmanagement-waitlistid"),
                sortable: true,
                curSortDirection: this.state[resType].SortFields[SortType.WAITLISTID].curSortDirection,
                onSort: () => {
                    this.onSortClicked(resType, SortType.WAITLISTID)
                },
                activeSort: this.state[resType].activeSortField === SortType.WAITLISTID,
            }
        ];
        headers.push(
            {
                text: localize("Status"),
                sortable: false,
                curSortDirection: SortDirection.ASC,
                onSort: () => {},
                activeSort: false,
            }
        );
    
        //only show room type if showing All
        if (showAll) {
            headers.push(
                {
                    text: localize("Resort"),//localize("static.content.waitlistmanagement-first-segment-resort"),
                    sortable: false,
                    curSortDirection: SortDirection.ASC,
                    onSort: () => {},
                    activeSort: false,
                }
            );
        }

        //always show Dates/Nights
        headers.push(
            {
                text:localize("Check In Date"), // localize("static.content.waitlistmanagement-first-segment-checkin"),
                sortable: false,
                curSortDirection: SortDirection.ASC,
                onSort: () => {},
                activeSort: false,
            }            
        )

        //show the rest of the columns if showing All, except for points applied - do not show if res type is canceled
        if (showAll) {
            headers.push(
                {
                    text:localize("Transaction Date"), // localize("static.content.waitlistmanagement-transaction-date"),
                    sortable: true,
                    curSortDirection: this.state[resType].SortFields[SortType.TRANSACTION_DATE].curSortDirection,
                    onSort: () => {
                        this.onSortClicked(resType, SortType.TRANSACTION_DATE)
                    },
                    activeSort: this.state[resType].activeSortField === SortType.TRANSACTION_DATE,
                }, {
                    text: localize("Points Applied"), //localize("static.content.waitlistmanagement-points-applied"),
                    sortable: false,
                    curSortDirection: SortDirection.ASC,
                    onSort: () => {},
                    activeSort: false,
                },
            );
        }

        //always show View column
        headers.push(
            {
                text: "",
                sortable: false,
                curSortDirection: SortDirection.ASC,
                onSort: () => {},
                activeSort: false,
            },
        )

        return headers;

    }
    getReservationDetails =(resDetails:any)=>{

        return { 
            pointsRequired:  resDetails.minOfMinPoints+' - '+ resDetails.maxOfMaxpoints,
            resortName: resDetails.name,
            resortId:resDetails.resortId,
            resortImage: resDetails.resortImage,
            resortLocation: resDetails.continent+","+resDetails.state+","+resDetails.continent,
            // roomType: resDetails.roomType[0],
            checkInDate:resDetails.checkInStartDate,
            checkOutDate: resDetails.checkInEndDate,
            numOfNights: resDetails.numberOfNights,
            numOfGuests: 1,
            checkInDays:[],
            accessibility: []
}
    }

    getTransDateNoTime = (date: string|Date): Moment => {
        // if(!date){
        //     return moment()
        // }
        return moment(date.toString().split('T')[0]);
    };

    /**
     * return the jsx for each cell in the Reservations table
     */
    waitlistTableRows(resType: WaitlistManagementType) {
        const showAll = this.showAllColumns();

        return this.state[resType].waitlists.map(resDetails => {
            const { localize } = this.context;
            const transDate = this.getTransDateNoTime(resDetails.lastUpdateDate).format("DD MMM YYYY");
            

            const rowCells:any = {
                waitlistId: this.getWaitlistIDJSX(resType, resDetails), //resort info?
            }

            rowCells.status = <p className='statusName'>{resDetails.status.code}</p>;
            if (showAll) {
                rowCells.firstSegmentData = this.getFirstSegmentData(resType, resDetails);
            }

            rowCells.firstSegmentCheckInDate = this.getDatesJSX(resDetails);            
        

            if (showAll) {
                rowCells.transactionDate = <p aria-label="transDate">{transDate}</p>;
                rowCells.points = <p aria-label="reservationConfirmationNumber">{resDetails.maxPointsToApply}</p>;
               
            }

            rowCells.view = this.getViewJSX(resDetails.waitlistId, resType);
             
            return {
                rowKey: resDetails.waitlistId.toString(),
                rowCells,
                rowExpanded: (<>{resDetails.segments.map((segment:any,index:number)=>{
                        const reservationDetails:any = this.getReservationDetails(segment); 
                        return (
                            <BookingInfoExists
                                currentSegment={index + 1}
                                totalNoOfSegments={resDetails.segments.length}
                                waitlistReservationID={0} //TODO: Need to fix
                                waitlistRooms={resDetails.waitlistRooms || []}
                                // pointAmountMin={0} //TODO: Need to fix
                                reservationDetails={reservationDetails}
                                //pointsRequired={String(this.state.waitlistReservationDetails.pointsRequired)}
                                onEditSegmentClick={() => this.goToViewReservation(resDetails.waitlistId, resType)}
                                readOnly={false}
                                visitResortNewTab={false}
                                hideHeader={true}
                                noOfSegmentsInWaitlist={0}
                            />
                        )
                        }
                        )}
                     </>)
            };
        });
    }

    getWaitlistIDJSX(resType: WaitlistManagementType, resDetails: any) {
        //show hyperlink given certain conditions, otherwise just show text
        let showDestinationLink = false;
        const siteType = resDetails.managementCompany ? resDetails.managementCompany.siteType : "";
        if (resType !== WaitlistManagementType.Active && (siteType === SiteType.MVC || ((siteType === SiteType.EXCHANGE || siteType === SiteType.EXPLORER)))) {
            showDestinationLink = true;
        }

        if (showDestinationLink) {
            return <>
                <div className="name-address">
                    <div
                        className="resort-name"
                        onClick={() =>
                            {
                                switch (siteType) {
                                    case SiteType.MVC:
                                        this.toggleResortModal(resDetails.resortId ? resDetails.resortId : "");
                                        break;
                                    case SiteType.EXPLORER:
                                        window.location.href = "../explorerCollection.jsp";
                                        break;
                                    case SiteType.EXCHANGE:
                                        window.location.href = "../mvcAsiaPacific.jsp";
                                        break;
                                }
                            }
                        }
                    >
                        <span>
                            {resDetails.resortName}
                        </span>
                    </div>
                    <div className="resort-address">
                        <span>
                            {siteType === SiteType.MVC ? resDetails.resortLocation : ""}
                        </span>
                    </div>
                </div>
            </>
        }
        else {
            return <>
                <div className="name-address">
                    <p aria-label="resortName">{resDetails.waitlistId}</p>
                    <p aria-label="resortLocation">{siteType === SiteType.MVC ? resDetails.resortLocation : ""}</p>
                </div>
            </>
        }
    }

    getFirstSegmentData(resType: WaitlistManagementType, resDetails: any) {
        //room type - show hyperlink given certain conditions, otherwise just show text
        let showRoomTypeLink = false;
        if (resType === WaitlistManagementType.Active && (resDetails.managementCompany && resDetails.managementCompany.siteType === SiteType.MVC)) {
            showRoomTypeLink = true;
        }
        
        const segments = JSON.parse(sessionStorage.read(WaitlistManagementService.SEGMENTS));

          const handleRoomModal = () => {
            this.fetchFloorPlan({ 
            segments: segments || ["PTS", "INA", "AP2"],
            resorts : [resDetails.resortId],
            codeRoomPoolCode: [resDetails.roomPoolCode]})
            this.setState({
              [ModalTypes.ROOM_MODAL]: {
                ...this.state[ModalTypes.ROOM_MODAL],
                room: {} as any,
                show: true,
              },
            })
          }

        if (showRoomTypeLink) {
            return <>
                <div className="room-type">
                    <span
                        onClick={handleRoomModal}
                    >
                        "test"
                    </span>
                </div>
            </>
        }
        else {
            return <>
                <p aria-label="roomType">{resDetails.segments[0].name}</p>
            </>
        }
    }

    getDatesJSX(resDetails: any) {
        const checkIn = moment(resDetails.segments[0].checkInStartDate).format("DD MMM YYYY");
        const checkOut =resDetails.segments[0].checkInEndDate ? moment(resDetails.segments[0].checkInEndDate).format("DD MMM YYYY") : "";
       
        return <>
                <div>
                <span>
                    {checkIn} &nbsp;-&nbsp;
                </span>
                </div>
        
                <div>
                <span>
                    {checkOut ? checkOut : ""}
                </span>
                </div>
            
        </>
    }

    showResField(resViewField:ReservationViewFields, resDetails: any) {
        return showReservationField(resViewField, resDetails);
    }

    getReservationTypeJSX(resType: WaitlistManagementType, resDetails: any) {
        let showPopup = false;
        if (
            (resType === WaitlistManagementType.Active || resType === WaitlistManagementType.InActive)
            && (resDetails.managementCompany && resDetails.managementCompany.name !== ManagementCompanyType.MVC)
            && (resDetails.managementCompany && (resDetails.managementCompany.phone || resDetails.managementCompany.url))
            && (this.showResField(ReservationViewFields.HOVER_POP_UP, resDetails))
        ) {
            showPopup = true;
        }

        let reservationTypeContent = '';
        if (resDetails.managementCompany) {
            reservationTypeContent = resDetails.managementCompany.name;
        }

        if (showPopup && resDetails.managementCompany) {
            return (
                <div className="reservation-type-container">
                    <MvReservationTypeToolTip
                        resID = {resDetails.waitlistId}
                        managementCompany = {resDetails.managementCompany}
                        position = {Position.CENTER}
                    >
                        <span key={resDetails.waitlistId} aria-label="reservationType" className="reservation-type">{reservationTypeContent}</span>
                    </MvReservationTypeToolTip>
                </div>
            );
        }
        else {
            return <>
                <p aria-label="reservationType">{reservationTypeContent}</p>
            </>
        }
    }

    getViewJSX(resId: number, resType: WaitlistManagementType) {
        const { localize } = this.context;
        return <>
            <div className="view-link">
                {/* Commenting out this feature for Nato users  */}
                {/* <span onClick={() => this.goToViewReservation(resId, resType)}>
                    {localize("static.content.waitlists-view-link")}
                </span> <br></br> */}
                {/* <span onClick={() => this.goToViewReservation(resId, resType)}>
                        {localize("Cancel")}
                </span> */}
            </div>
        </>
    }

    goToViewReservation = (resId: number, resType: WaitlistManagementType) => {
        // if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        //     this.props.setScreenType(ScreenType.VIEW_RESERVATION, resId, resType);
        // }
        // else {
        //     // VCAP (production)
        //     window.location.href = `/viewReservation.jsp?resId=${resId}&resType=${resType}`;
        //
        this.props.setScreenType(ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW, -1, resId);
    };

    getColumnStyles(resType: WaitlistManagementType) {
        let columnStyles: {[key: string]: CSSProperties} = {
            "0": {
                flex: "120px  0 0"
            },
            "1": {
                flex: "120px 0 0"
            },
            "2": {
                flex: "1"
            },
            "3": {
                flex: "220px 0 0"
            },
            "4": {
                flex: "220px 0 0"
            },
            "5": {
                flex: "150px 0 0",
            },
            "6": {
                flex: "150px 0 0",
            },
        }
        // //cancelled list removes points applied (column #7 above)
        // if (resType === WaitlistManagementType.CANCELED) {
        //     columnStyles = {
        //         "0": {
        //             flex: "1"
        //         },
        //         "1": {
        //             flex: "1"
        //         },
        //         "2": {
        //             flex: "120px 0 0"
        //         },
        //         "3": {
        //             flex: "80px 0 0"
        //         },
        //         "4": {
        //             flex: "125px 0 0"
        //         },
        //         "5": {
        //             flex: "150px 0 0",
        //         },
        //         "6": {
        //             flex: "150px 0 0",
        //         },
        //         "7": {
        //             flex: "50px 0 0",
        //         }
        //     }
        // }
        if (!this.showAllColumns()) {
            columnStyles = {
                "0": {
                    flexBasis: '30%'
                },
                "3": {
                    flex: "50px 0 0"
                }
            }
        }
        return columnStyles;
    }

    toggleResortModal(propertyCode: string) {
        this.setState({
            resortModal: {
                propertyCode,
                show: !this.state.resortModal.show,
            },
        });
    }

    /**
     * fired when a column sort icon is clicked in the Reservation list table
     */
    onSortClicked(reservationType: WaitlistManagementType, sortField: SortType) {
        const table = {...this.state[reservationType]};
        const activeSortField = table.activeSortField;
        const sortTable = table.SortFields;
        const waitlists = [...table.waitlists];

        let sortDirection = table.SortFields[sortField].curSortDirection;
        if (activeSortField === sortField) {
            sortDirection = sortTable[sortField].curSortDirection === SortDirection.ASC ?
                SortDirection.DESC : SortDirection.ASC;
        }
        else {
            // reset previous sort direction to default
            sortTable[activeSortField].curSortDirection = sortTable[activeSortField].defaultSortDirection;
        }

        const sortedReservations =sortReservations(
            waitlists,
            reservationType,
            sortField,
            sortDirection
        );

        sortTable[sortField].curSortDirection = sortDirection;
        table.waitlists = [...sortedReservations];


        const newState = { ...this.state };
        newState[WaitlistManagementType[reservationType]] = table;
        newState[WaitlistManagementType[reservationType]].activeSortField = sortField;
        newState[WaitlistManagementType[reservationType]].SortFields = sortTable;
        this.setState(newState);
    }

    getYearFromDate(date: string | Date) {
        const checkIn = moment(date).format("YYYY");
        if (checkIn && checkIn.length) {
            return Number(checkIn);
        }
        return 0
    }

    onYearFilterSelection(years: DropdownOption[], resType: WaitlistManagementType) {
        if (this.state && this.state[resType] && this.state[resType].totalWaitlists) {
            const selectedOptions = years.filter((item) => {
                return item.checked;
            })
            let selectedYears = selectedOptions.map(item => Number(item.year))
            // TODO: This may need when we want to implement default year logic 
            // if (selectedYears && selectedYears.length === 0) {
            //     selectedYears = this.state[resType].defaultYears;
            // }
            const totalWaitlists = [...this.state[resType].totalWaitlists];
            if (totalWaitlists && totalWaitlists.length) {
                let filteredReservations = [];
                 filteredReservations = totalWaitlists.filter((item) => {
                    return selectedYears.includes(this.getYearFromDate(item.reservationDetails.checkInDate))
                });
                if(selectedYears && selectedYears.length === 0){
                    filteredReservations = totalWaitlists;
                }
                this.setState({
                    ...this.state,
                    [resType]: {
                        ...this.state[resType],
                        waitlists: filteredReservations
                    }
                })
            }

        }
    }

        
    /**
     * toggle a modal of a given type
     */
    toggleModal = (modalType: ModalTypes): void => {
        if(this.state[modalType].show == true){
        this.setState({roomModalLoaded: false})
        console.log('(*(&&^%^&*(')
        }
        this.setState({
        [modalType]: {
            ...this.state[modalType],
            show: !this.state[modalType].show
        },
        } as any);
    }

    fetchFloorPlan(roomParams:any) {
        // this.WaitlistManagementService.searchRoomInfo(roomParams).then(res => {
        //     this.setState({
        //         singleRoomInfo: res,
        //         roomModalLoaded: true,
        //     });
        // });
    } 

    render() {
        const { localize } = this.context;
            
        return (
            <div className='waitlists-page'>
                <h2 className="table-title">{localize("Waitlist Management")}</h2>
                <WaitlistManagementBtnContainer setActive={this.setActive} activeBtn={this.state.activeBtn.toString()} />
                <MvConfirmationModal
                    header = "Error"//{localize("static.content.waitlists-error-header")}
                    description = {this.state.errorMessage}
                    message = ""
                    abortLabel = ""
                    confirmLabel = {localize("OK")} //{localize("static.content.waitlists-confirm-error")}
                    openModal={this.state.showErrorModal}
                    toggleModal={this.toggleErrorModal}
                    confirm={this.toggleErrorModal}
                    abort={() => {}}
                />
                <div className="waitlists-container">
                <MvRoomModal
                    toggle={() => this.toggleModal(ModalTypes.ROOM_MODAL)}
                    data={{...this.state[ModalTypes.ROOM_MODAL], ...this.state.singleRoomInfo[0]}}
                    fetchLoaded={this.state.roomModalLoaded}
                />
                    <MvResortModal
                        show={this.state.resortModal.show}
                        propertyCode={this.state.resortModal.propertyCode}
                        toggle={() => this.setState({ resortModal: { ...this.state.resortModal, show: !this.state.resortModal.show } })}
                    />
                    {(this.state.activeBtn === WaitlistManagementType.Active) &&
                        <MvSortTable
                            rowKey="resId"
                            headers={this.reservationsTableHeaders(WaitlistManagementType.Active)}
                            rows={this.waitlistTableRows(WaitlistManagementType.Active)}
                            rowsExpandable={true}
                            tableExpandable={false}
                            dataStatus={this.state[WaitlistManagementType.Active].requestStatus}
                            headerSection={
                            <div className="waitlists-header">
                                <h4>
                                    {localize("Active Waitlist")}
                                </h4>
                                <span className="waitlists-subheader">
                                    {localize("To be filled")}
                                </span>
                                {this.state[WaitlistManagementType.Active].requestStatus === RequestStatus.LOADED && this.state[WaitlistManagementType.Active].waitlists.length === 0 &&
                                    <div className="waitlists-none">{localize("You currently do not have any active waitlists")}</div>
                                }
                            </div>
                            }
                            minWidth={1}
                            columnStyles={this.getColumnStyles(WaitlistManagementType.Active)}
                            apiTimeout = {this.props.apiTimeout}
                        />
                     }
                    {/* {(this.state.activeBtn === WaitlistManagementType.InActive) &&
                        <MvSortTable
                            rowKey="resId"
                            headers={this.reservationsTableHeaders(WaitlistManagementType.InActive)}
                            rows={this.waitlistTableRows(WaitlistManagementType.InActive)}
                            rowsExpandable={true}
                            dataStatus={this.state[WaitlistManagementType.InActive].requestStatus}
                            headerSection={
                            <div className="waitlists-header">
                                <h4>
                                    {localize("static.content.waitlist-management-inactive-heading")}
                                </h4>
                                <span className="waitlists-subheader">
                                {localize("static.content.waitlist-management-inactive-sub-heading")}
                                </span>
                                {this.state[WaitlistManagementType.InActive].requestStatus === RequestStatus.LOADED && this.state[WaitlistManagementType.InActive].waitlists.length === 0 &&
                                    <div className="waitlists-none">{localize("You currently do not have any inActive Waitlists for the given years")}</div>
                                }
                                <span className="multi-select-year-filter">
                                     <MultiSelectDate options={this.state[WaitlistManagementType.InActive].datesFilter} onChangeFilter={(years)=> {this.onYearFilterSelection(years, WaitlistManagementType.InActive)}} label={localize("static.content.view-res-more-filters")}></MultiSelectDate>
                                </span>
                            </div>
                            }
                            minWidth={1}
                            columnStyles={this.getColumnStyles(WaitlistManagementType.InActive)}
                        />
                     } */}
                </div>
            </div>
        );
    }

};

WaitlistManagement.contextType = LocalizationContext;
export {
    WaitlistManagement,
};